export default {
    timeRange(beginTime, endTime) {
      const strb = beginTime.split(':')
      if (strb.length != 3) {
        return false;
      }
      const stre = endTime.split(':')
      if (stre.length != 3) {
        return false;
      }
      const b = new Date();
      const e = new Date();
      const n = new Date();
      b.setHours(strb[0])
      b.setMinutes(strb[1])
      e.setHours(stre[0])
      e.setMinutes(stre[1])
      if (n.getTime() - b.getTime() > 0 && n.getTime() - e.getTime() < 0) {
        return true;
      }
      return false;
    },
    FormatDate(strTime) {
        const date = new Date(strTime);
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    fmtDate(date, fmt) {
      if (!date) {
        return ''
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'q+': Math.floor((date.getMonth() + 3) / 3),
        'S': date.getMilliseconds(),
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length))
      }
      Object.keys(o).forEach((k) => {
        if (new RegExp(`(${k})`).test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length)))
        }
      })
      return fmt
    },
}
